import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import RefService from "@/services/ReferensiDataAskeb";
import AsuhanKebidananGawatDarurat from "@/services/AsuhanKebidananGawatDarurat";

interface RefData {
  id: number;
  name: string;
}

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "asuhan-kebidanan-gadar"
})
class AsuhanKebidananGadarStore extends VuexModule {
  listDiag: RefData[] = [];
  listIntervensi: RefData[] = [];
  listAsKeb = [];

  get isAllRefExist(): boolean {
    return this.listDiag.length > 0 && this.listIntervensi.length > 0;
  }

  @Mutation
  SET_LIST_DIAG(val: RefData[]) {
    this.listDiag = val;
  }

  @Mutation
  SET_LIST_INTERVENSI(val: RefData[]) {
    this.listIntervensi = val;
  }

  @Mutation
  SET_LIST_ASKEB(val: []) {
    this.listAsKeb = val;
  }

  @Action({ rawError: true })
  async getListDiagnosis(): Promise<void> {
    const response = await RefService.getDiagnosis();

    this.SET_LIST_DIAG(response.data);
  }

  @Action({ rawError: true })
  async getListIntervensi(): Promise<void> {
    const response = await RefService.getIntervensi();

    this.SET_LIST_INTERVENSI(response.data);
  }

  @Action({ rawError: true })
  async getAllRefList(force = false): Promise<void> {
    if (!this.isAllRefExist || force) {
      this.getListDiagnosis();
      this.getListIntervensi();
    }
  }

  @Action({ rawError: true })
  async getListAskeb(register): Promise<void> {
    const response = await AsuhanKebidananGawatDarurat.getByRegister(register);
    this.SET_LIST_ASKEB(response.data);
  }
  @Action({ rawError: true })
  async clearListAskeb(): Promise<void> {
    this.SET_LIST_ASKEB([]);
  }
}

export default getModule(AsuhanKebidananGadarStore);
